<app-ui-card>
<div class="account-card">
  <div class="account-card__header-wrapper">
    <div class="account-card__header-icon">
      <img src="assets/images/router.svg" alt="router"/>
    </div>
    <div class="account-card__header">

      <h2>{{ user?.name }}</h2>
      <div class="account-card__info">
        <div class="account-card__info-item">
          <span>Лицевой счет</span>
          <p>{{ user?.pno }}</p>
        </div>
        <div class="account-card__info-item">
          <span>Учетная запись</span>
          <p>{{ user?.login }}</p>
        </div>
        <div class="account-card__info-item">
          <span>IP-Адрес</span>
          <p>{{ clientIp }}</p>
        </div>
      </div>
    </div>

  </div>

  <div *ngIf="voluntaryBlocking" class="account-card__alert">
    <i class="pi pi-exclamation-triangle"></i>
    <span>{{ user?.info }}</span>
  </div>

  <div class="account-card__actions">
    <button
      pButton label="Войти в интернет"
      icon="pi pi-arrow-right"
      iconPos="right"
      (click)="coaAuth()">
    </button>
    <button
      pButton
      label="Сменить пароль"
      icon="pi pi-key"
      iconPos="right"
      (click)="showChangePasswordDialog()">
    </button>
  </div>

</div>
</app-ui-card>
